<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">查看</v-toolbar-title>

        <v-spacer/>

        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <div class="x-text-field">
                <label>联合申报项目名称</label>
                <div>{{item.name}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6>
              <div class="x-text-field">
                <label>项目负责人</label>
                <div>{{item.leaderName}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6>
              <div class="x-text-field">
                <label>负责人联系电话</label>
                <div>{{item.leaderPhone}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6>
              <div class="x-text-field">
                <label>归属部门</label>
                <div>{{item.department? item.department.name: ''}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6>
              <div class="x-text-field">
                <label>主管部门</label>
                <div>{{item.adminDept? item.adminDept.name: ''}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm4>
              <div class="x-text-field">
                <label>合同类型</label>
                <div>{{item.type? item.type.name: ''}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm4>
              <div class="x-text-field">
                <label>合同性质</label>
                <div>{{ properties[item.property]}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm4>
              <div class="x-text-field">
                <label>是否招投标项目</label>
                <div>{{item.bidding? '是': '否'}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm8>
              <div class="x-text-field">
                <label>{{clientLabel}}名称</label>
                <div>{{item.client}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm4>
              <div class="x-text-field">
                <label>{{clientLabel}}性质</label>
                <div>{{item.clientType? item.clientType.name:''}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6>
              <div class="x-text-field">
                <label>合同金额</label>
                <div>{{item.amount | currency}}元</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6>
              <div class="x-text-field">
                <label>技术交易额</label>
                <div>{{item.turnover | currency}}元</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6>
              <div class="x-text-field">
                <label>开始日期</label>
                <div>{{item.startDate}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6>
              <div class="x-text-field">
                <label>结束日期</label>
                <div>{{item.finishDate}}</div>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="x-text-field">
                <label>所属行业领域</label>
                <div>{{item.industryClass? item.industryClass.name : ''}}</div>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="x-text-field">
                <label>备注</label>
                <div>{{item.note}}</div>
              </div>
            </v-flex>

            <v-flex
              xs12
              v-if="item.attachments && item.attachments.length > 0"
            >
              <p class="my-1">附件列表：</p>
              <v-divider/>
              <ol>
                <li v-for="a in item.attachments" :key="a.dbid" class="pt-1">
                  <a :href="`${fileUri}/${a.dbid}`" target="_self">
                    {{a.fileName}}
                    ({{a.size | fileSize }})
                  </a>
                </li>
              </ol>
            </v-flex>

            <v-flex
              xs12
              v-if="item.extraAttachments && item.extraAttachments.length > 0"
            >
              <p class="my-1">附加附件列表：</p>
              <v-divider/>
              <ol>
                <li v-for="a in item.extraAttachments" :key="a.dbid" class="pt-1">
                  <a :href="`${fileUri}/${a.dbid}`" target="_self">
                    {{a.fileName}}
                    ({{a.size | fileSize }})
                  </a>
                </li>
              </ol>
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn
          v-if="funcIds.includes('c_proj_project')"
          :disabled="!(funcIds.includes('c_proj_project') && item.statusId === 'checked')"
          color="orange"
          flat
          :to="`/proj/create?contractId=${dbid}`">
          <v-icon>add</v-icon>
          项目立项
        </v-btn>
        <v-btn color="primary" @click.native="visible=false">关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import {mapGetters} from 'vuex'
  import mixin from '@/mixin'

  const baseUri = '/api/coop/cooperation';

  export default {
    mixins: [mixin.view(baseUri)],

    data() {
      return {
        fileUri: '/api/agmt/file',

        item: {},

        properties: {
          "wt": '委托合同',
          "ww": '外委合同'
        },
      }
    },
    computed: {
      ...mapGetters(['funcIds']),
      clientLabel() {
        return this.item.property === 'ww' ? '受托单位' : '委托单位'
      }
    },
  }
</script>
